


















































import { Vue, Component, Prop } from 'vue-property-decorator';
import ToolBarSelect from './tool-bar-select.vue';
import ToolBarEndpointSelect from './tool-bar-endpoint-select.vue';
import { State, Action, Mutation } from 'vuex-class';
@Component({components: {ToolBarSelect, ToolBarEndpointSelect}})
export default class ToolBar extends Vue {
  @Prop() private compType!: any;
  @Prop() private stateDashboard!: any;
  @Prop() private rocketGlobal!: any;
  @Prop() private rocketComps!: any;
  @Prop() private durationTime!: any;
  @Mutation('ADD_COMP') private ADD_COMP: any;
  @Action('SET_EDIT') private SET_EDIT: any;
  @Action('SELECT_SERVICE') private SELECT_SERVICE: any;
  @Action('SELECT_DATABASE') private SELECT_DATABASE: any;
  @Action('SELECT_ENDPOINT') private SELECT_ENDPOINT: any;
  @Action('SELECT_INSTANCE') private SELECT_INSTANCE: any;
  @Action('MIXHANDLE_GET_OPTION') private MIXHANDLE_GET_OPTION: any;
  get lastKey() {
    const current = this.rocketComps.tree[this.rocketComps.group]
    .children[this.rocketComps.current].children;
    if (!current.length) { return 0; }
    return current[current.length - 1].k;
  }
  private handleOption() {
    return this.MIXHANDLE_GET_OPTION({compType: this.compType, duration: this.durationTime});
  }
  private handleSetEdit() {
     this.SET_EDIT(this.rocketGlobal.edit ? false : true);
  }
  private selectService(i: any) {
    this.SELECT_SERVICE({service: i, duration: this.durationTime});
  }
  private selectEndpoint(i: any) {
    this.SELECT_ENDPOINT({endpoint: i, duration: this.durationTime});
  }
  private selectInstance(i: any) {
    this.SELECT_INSTANCE({instance: i, duration: this.durationTime});
  }
}
